import { defineKey as T } from '@ha/intl';

import { FacilitiesValues } from './constants';

export const FacilitiesLocators = {
  ac: 'Air conditioning',
  allergy_friendly: 'Allergy friendly',
  animal_allowed: 'Animal allowed',
  balcony_terrace: 'Balcony/Terrace',
  basement: 'Basement',
  bathroom: 'Bathroom',
  bed: 'Bed',
  bedroom_count: 'Bedroom count',
  bedroom_furnished: 'Bedroom furnished',
  bedroom_size: 'Bedroom size',
  closet: 'Closet',
  desk: 'Desk',
  dishwasher: 'Dishwasher',
  dryer: 'Dryer',
  flooring: 'Flooring',
  garden: 'Garden',
  heating: 'Heating',
  housemates_gender: 'Housemates gender',
  kitchen: 'Kitchen',
  kitchenware: 'Kitchenware',
  living_room: 'Living room',
  lock: 'Lock on bedroom',
  lroom_furniture: 'Living room furniture',
  parking: 'Parking',
  play_music: 'Play musical instrument',
  registration_possible: 'Registration possible',
  smoking_allowed: 'Smoking allowed',
  toilet: 'Toilet',
  total_size: 'listing.create.section_property.property_size.label',
  total_size_ft: 'listing.create.section_property.property_size.label_sqft',
  tv: 'TV',
  washing_machine: 'Washing machine',
  wheelchair_accessible: 'Wheelchair accessible',
  wifi: 'Wifi',
};

export const FacilitiesTranslations = {
  ac: T('Air conditioning'),
  allergy_friendly: T('Allergy friendly'),
  animal_allowed: T('Animal allowed'),
  balcony_terrace: T('Balcony/Terrace'),
  basement: T('Basement'),
  bathroom: T('Bathroom'),
  bed: T('Bed'),
  bedroom_count: T('Bedroom count'),
  bedroom_furnished: T('Bedroom furnished'),
  bedroom_size: T('Bedroom size'),
  closet: T('Closet'),
  desk: T('Desk'),
  dishwasher: T('Dishwasher'),
  dryer: T('Dryer'),
  flooring: T('Flooring'),
  garden: T('Garden'),
  heating: T('Heating'),
  housemates_gender: T('Housemates gender'),
  kitchen: T('Kitchen'),
  kitchenware: T('Kitchenware'),
  living_room: T('Living room'),
  lock: T('Lock on bedroom'),
  lroom_furniture: T('Living room furniture'),
  parking: T('Parking'),
  play_music: T('Play musical instrument'),
  registration_possible: T('Registration possible'),
  smoking_allowed: T('Smoking allowed'),
  toilet: T('Toilet'),
  total_size: T('listing.create.section_property.property_size.label'),
  total_size_ft: T('listing.create.section_property.property_size.label_sqft'),
  tv: T('TV'),
  washing_machine: T('Washing machine'),
  wheelchair_accessible: T('Wheelchair accessible'),
  wifi: T('Wifi'),
};

export const FacilitiesInputTranslations = {
  allergy_friendly: T('Allergy friendly'),
  animal_allowed: T('listingCreation_Rules_Pets'),
  play_music: T('listingCreation_Rules_Instrument'),
  registration_possible: T('landlord.registration_question'),
  smoking_allowed: T('listingCreation_Rules_Smoking'),
  wheelchair_accessible: T('Wheelchair accessible'),
};

export const FacilitiesValuesTranslations = {
  [FacilitiesValues.Carpet]: T('Carpet'),
  [FacilitiesValues.Central]: T('Central heating'),
  [FacilitiesValues.Discussable]: T('Discussable'),
  [FacilitiesValues.Electrical]: T('Electrical'),
  [FacilitiesValues.Gas]: T('Gas'),
  [FacilitiesValues.Laminate]: T('Laminate'),
  [FacilitiesValues.LookingForJob]: 'looking for a job',
  [FacilitiesValues.No]: T('No'),
  [FacilitiesValues.Other]: T('Other'),
  [FacilitiesValues.OutsideOnly]: T('Outside only'),
  [FacilitiesValues.Plastic]: T('Plastic'),
  [FacilitiesValues.PreferredFemale]: T('female'),
  [FacilitiesValues.PreferredMale]: T('male'),
  [FacilitiesValues.Private]: T('Private'),
  [FacilitiesValues.Shared]: T('Shared'),
  [FacilitiesValues.SharedWithBoth]: T('Shared with boys/girls'),
  [FacilitiesValues.SharedWithBoys]: T('Shared with boys'),
  [FacilitiesValues.SharedWithGirls]: T('Shared with girls'),
  [FacilitiesValues.Stone]: T('Stone'),
  [FacilitiesValues.Student]: T('student'),
  [FacilitiesValues.Studio]: T('Studio'),
  [FacilitiesValues.Wood]: T('Wood'),
  [FacilitiesValues.WoodStove]: T('Wood Stove'),
  [FacilitiesValues.Working]: T('working'),
  [FacilitiesValues.WorkingStudent]: T('working student'),
  [FacilitiesValues.Yes]: T('Yes'),
};

export const FacilitiesGroupsTranslations = {
  spaceOverview: T('Facilities'),
  amenities: T('listing.facilities_group.amenities'),
  rules: T('listing.facilities_group.rules'),
};

export const FacilitiesDetailsTranslations = {
  parking: {
    no: T('listing.facilities.parking.no'),
    shared: T('listing.facilities.parking.shared'),
    private: T('listing.facilities.parking.private'),
  },
  living_room: {
    no: T('listing.facilities.living_room.no'),
    shared: T('listing.facilities.living_room.shared'),
    private: T('listing.facilities.living_room.private'),
  },
  garden: {
    no: T('listing.facilities.garden.no'),
    shared: T('listing.facilities.garden.shared'),
    private: T('listing.facilities.garden.private'),
  },
  toilet: {
    no: T('listing.facilities.toilet.no'),
    shared: T('listing.facilities.toilet.shared'),
    private: T('listing.facilities.toilet.private'),
  },
  kitchen: {
    no: T('listing.facilities.kitchen.no'),
    shared: T('listing.facilities.kitchen.shared'),
    private: T('listing.facilities.kitchen.private'),
  },
  basement: {
    no: T('listing.facilities.basement.no'),
    shared: T('listing.facilities.basement.shared'),
    private: T('listing.facilities.basement.private'),
  },
  bathroom: {
    no: T('listing.facilities.bathroom.no'),
    private: T('listing.facilities.bathroom.private'),
    shared_w_boys: T('listing.facilities.bathroom.boys'),
    shared_w_girls: T('listing.facilities.bathroom.girls'),
    shared_w_both: T('listing.facilities.bathroom.mixed'),
  },
  balcony_terrace: {
    no: T('listing.facilities.balcony_terrace.no'),
    shared: T('listing.facilities.balcony_terrace.shared'),
    private: T('listing.facilities.balcony_terrace.private'),
  },
  wifi: {
    yes: T('listing.facilities.wifi.yes'),
    no: T('listing.facilities.wifi.no'),
  },
  lroom_furniture: {
    yes: T('listing.facilities.lroom_furniture.yes'),
    no: T('listing.facilities.lroom_furniture.no'),
  },
  bed: {
    yes: T('listing.facilities.bed.yes'),
    no: T('listing.facilities.bed.no'),
  },
  tv: {
    yes: T('listing.facilities.tv.yes'),
    no: T('listing.facilities.tv.no'),
  },
  lock: {
    yes: T('listing.facilities.lock.yes'),
    no: T('listing.facilities.lock.no'),
  },
  kitchenware: {
    no: T('listing.facilities.kitchenware.no'),
    shared: T('listing.facilities.kitchenware.shared'),
    private: T('listing.facilities.kitchenware.private'),
  },
  ac: {
    yes: T('listing.facilities.ac.yes'),
    no: T('listing.facilities.ac.no'),
  },
  washing_machine: {
    yes: T('listing.facilities.washing_machine.yes'),
    no: T('listing.facilities.washing_machine.no'),
  },
  dryer: {
    yes: T('listing.facilities.dryer.yes'),
    no: T('listing.facilities.dryer.no'),
  },
  closet: {
    yes: T('listing.facilities.closet.yes'),
    no: T('listing.facilities.closet.no'),
  },
  heating: {
    no: T('listing.facilities.heating.no'),
    central: T('listing.facilities.heating.central'),
    gas: T('listing.facilities.heating.gas'),
    wood_stove: T('listing.facilities.heating.wood_stove'),
    electrical: T('listing.facilities.heating.electrical'),
  },
  flooring: {
    laminate: T('listing.facilities.flooring.laminate'),
    carpet: T('listing.facilities.flooring.carpet'),
    stone: T('listing.facilities.flooring.stone'),
    wood: T('listing.facilities.flooring.wood'),
    plastic: T('listing.facilities.flooring.plastic'),
    other: T('listing.facilities.flooring.other'),
  },
  dishwasher: {
    yes: T('listing.facilities.dishwasher.yes'),
    no: T('listing.facilities.dishwasher.no'),
  },
  wheelchair_accessible: {
    yes: T('listing.facilities.wheelchair_accessible.yes'),
    no: T('listing.facilities.wheelchair_accessible.no'),
  },
  play_music: {
    yes: T('listing.facilities.play_music.yes'),
    no: T('listing.facilities.play_music.no'),
    discussable: T('listing.facilities.play_music.discussable'),
  },
  animal_allowed: {
    yes: T('listing.facilities.animal_allowed.yes'),
    no: T('listing.facilities.animal_allowed.no'),
    discussable: T('listing.facilities.animal_allowed.discussable'),
  },
  smoking_allowed: {
    yes: T('listing.facilities.smoking_allowed.yes'),
    no: T('listing.facilities.smoking_allowed.no'),
    discussable: T('listing.facilities.smoking_allowed.discussable'),
    outside_only: T('listing.facilities.smoking_allowed.outside_only'),
  },
  desk: {
    yes: T('listing.facilities.desk.yes'),
    no: T('listing.facilities.desk.no'),
  },
};
